module.exports = __webpack_public_path__ + "static/media/ic_short_term_inv.5903bc18.svg";